// extracted by mini-css-extract-plugin
export default {"side-popup":"SidePopup_side-popup__WFVyw","popup":"SidePopup_popup__svYoy"};